import { TerminationOfExistingContract } from "features/contracting/enums/terminationOfExistingContract";
import { ContractingProcessAnswerProps } from "features/contracting/models/ContractingProcessAnswerProps";
import YesTerminationByUsSubForm from "./YesTerminationByUsSubForm";
import NoTerminationMyselfSubForm from "./NoTerminationMyselfSubForm";
import NoContractByAnotherSubForm from "./NoContractByAnotherSubForm";
import NoPlaceOfDeliveryNotConnectedSubForm from "./NoPlaceOfDeliveryNotConnectedSubForm";
import NoPlaceOfDeliveryNotExistsSubForm from "./NoPlaceOfDeliveryNotExistsSubForm";
import NoFixedContratDurationSubForm from "./NoFixedContratDurationSubForm";

type ContractingProcessSubForm = (props: ContractingProcessAnswerProps) => JSX.Element;
type ComponentMap = Record<TerminationOfExistingContract, ContractingProcessSubForm>;

export const ContractingProcessAnswersMap: ComponentMap = {
  YesTerminationByUs: YesTerminationByUsSubForm,
  NoTerminationMyself: NoTerminationMyselfSubForm,
  NoContractByAnother: NoContractByAnotherSubForm,
  NoPlaceOfDeliveryNotConnected: NoPlaceOfDeliveryNotConnectedSubForm,
  NoPlaceOfDeliveryNotExists: NoPlaceOfDeliveryNotExistsSubForm,
  NoFixedContratDuration: NoFixedContratDurationSubForm
}